import { MainSettings } from './main-settings';

export { MainSettings };
